import { useTranslation } from "@luckymenu/i18n/react";
import { useCan } from "@luckymenu/staff-core";
import { buttonVariants } from "@luckymenu/ui-web";
import { createFileRoute, Link } from "@tanstack/react-router";
import { List, ListPlus, Plus } from "lucide-react";
import { BottomBar } from "../features/menu/fields";
import { MenuList } from "../features/menu/menu-list";
import { PaneHint, useInPanes } from "../features/menu/panes";

export const Route = createFileRoute("/menu/")({ component: Page });

function Page() {
	const inPanes = useInPanes();
	const { t } = useTranslation("menu");
	const canEdit = useCan("menu.edit");
	if (inPanes) return <PaneHint />;
	return (
		<div className="max-w-3xl pb-24 md:pb-0">
			<MenuList
				canReorder={canEdit}
				actions={
					<>
						<Link to="/menu/categories" className={buttonVariants({ variant: "outline" })}>
							<List data-icon="inline-start" />
							{t("categories")}
						</Link>
						<Link to="/menu/addons" className={buttonVariants({ variant: "outline" })}>
							<ListPlus data-icon="inline-start" />
							{t("addons")}
						</Link>
						{canEdit ? (
							<Link to="/menu/items/new" className={buttonVariants({ className: "max-md:hidden" })}>
								<Plus data-icon="inline-start" />
								{t("addItem")}
							</Link>
						) : null}
					</>
				}
				emptyAction={
					canEdit ? (
						<Link to="/menu/categories/new" className={buttonVariants()}>
							<Plus data-icon="inline-start" />
							{t("addCategory")}
						</Link>
					) : null
				}
				categoryTitle={
					canEdit
						? (category) => (
								<Link
									to="/menu/categories/$categoryId"
									params={{ categoryId: category.id }}
									aria-label={t("editCategory", { name: category.name })}
									className="outline-none hover:underline focus-visible:underline"
								>
									{category.name}
								</Link>
							)
						: undefined
				}
				itemTitle={
					canEdit
						? (item) => (
								<Link
									to="/menu/items/$itemId"
									params={{ itemId: item.id }}
									className="outline-none after:absolute after:inset-0 hover:underline focus-visible:underline"
								>
									{item.name}
								</Link>
							)
						: undefined
				}
				categoryAction={
					canEdit
						? (category) => (
								<Link
									to="/menu/items/new"
									search={{ category: category.id }}
									aria-label={t("addItemTo", { category: category.name })}
									className={buttonVariants({ variant: "ghost", size: "icon" })}
								>
									<Plus />
								</Link>
							)
						: undefined
				}
				footer={
					canEdit ? (
						<div className="md:hidden">
							<BottomBar>
								<Link
									to="/menu/items/new"
									className={buttonVariants({ size: "lg", className: "w-full" })}
								>
									<Plus data-icon="inline-start" />
									{t("addItem")}
								</Link>
							</BottomBar>
						</div>
					) : null
				}
			/>
		</div>
	);
}
